import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentTemplateHeaderTypeModel, DocumentWithPassCodeModel } from "@/model/document/documentModel";
import service from "../../baseHttpService";
import {
  PrepareDocumentInputData,
  PrepareDocumentPublicLinkInputData,
  PrepareUpdateDetailDocumentInputData,
} from "../documentFacade";

class DebitNoteExpenseService {
  DoGetDebitNoteExpenseDocumentPublicLink(input: DocumentWithPassCodeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/DebitNote/GetDebitNoteExpenseDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetDebitNoteExpenseDocument(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/DebitNote/GetDebitNoteExpenseDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateDebitNoteExpenseDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/DebitNote/UpdateDebitNoteExpenseDetailDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}
export default new DebitNoteExpenseService();
